var _rect, _circle, _circle2, _g, _path, _path2, _g2, _g3, _circle3, _circle4, _circle5, _circle6, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrxwingoRound5M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 88,
    viewBox: "0 0 92 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 30,
    fill: "url(#paint0_linear_55_16326)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint1_linear_55_16326)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_16326",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint2_linear_55_16326)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_16326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 52L18.5 48L15.5 31L36 23L40 24L61.5 19.5003L105.126 53.9162L108 52L106.5 55.0003L105.126 53.9162L105 54L98 61.5L65.5 97.5003L21 61.0003L24 52Z",
    fill: "#4361C6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 55H7L12 61L9 55Z",
    fill: "#F4DE6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9866 9.35223L64.4014 12.9377C64.5402 13.2894 65.0006 13.3721 65.253 13.0907C65.3749 12.9549 65.4147 12.7641 65.3572 12.5909L64.1434 8.93244C63.9821 8.44626 63.3322 8.35829 63.0475 8.78411C62.9352 8.95202 62.9124 9.16433 62.9866 9.35223Z",
    fill: "#72FBBF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_55_16326)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 36.5,
    r: 29.5,
    fill: "url(#paint3_linear_55_16326)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_55_16326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5168 36.0998C25.9086 36.1565 24.5892 35.9439 23.5588 35.4619C22.153 34.8034 21.0356 33.7562 20.2066 32.3204C18.8446 29.9614 18.8396 27.3916 20.1915 24.6111C21.2561 22.458 23.2115 20.5599 26.0577 18.9166C29.8269 16.7405 33.0234 15.8522 35.6473 16.2518C38.284 16.6441 40.2315 17.9299 41.4898 20.1094C42.2226 21.3786 42.5483 22.7718 42.4669 24.2888C42.4022 25.4202 42.015 26.7036 41.3052 28.139C43.2528 27.989 44.9462 28.3018 46.3856 29.0777C47.8378 29.8461 48.9858 30.961 49.8296 32.4226C50.6438 33.8328 51.0793 35.3421 51.136 36.9503C51.1982 38.5384 50.9474 39.9396 50.3835 41.154C49.8325 42.361 48.9407 43.5255 47.7081 44.6474C46.4958 45.7747 45.0947 46.7973 43.505 47.7151C40.5178 49.4397 38.0322 50.4047 36.0482 50.61C34.0641 50.8153 32.2659 50.4689 30.6534 49.5709C29.0409 48.6728 27.7461 47.3776 26.769 45.6853C25.8142 44.0315 25.392 42.412 25.5024 40.8269C25.6055 39.2289 26.277 37.6532 27.5168 36.0998ZM27.8384 28.5295C28.401 29.5039 29.1575 30.1184 30.1079 30.373C31.0638 30.6075 32.0481 30.4323 33.0609 29.8476C33.9584 29.3295 34.5253 28.609 34.7617 27.6862C34.9982 26.7633 34.8462 25.834 34.3059 24.8981C33.7433 23.9237 32.9868 23.3092 32.0364 23.0545C31.0785 22.787 30.1317 22.9235 29.1958 23.4638C28.2471 24.0115 27.6454 24.7606 27.3907 25.7111C27.1414 26.6413 27.2907 27.5808 27.8384 28.5295ZM34.4212 40.9083C35.1392 42.1519 36.1059 42.9528 37.3212 43.311C38.5291 43.6563 39.6203 43.5477 40.5946 42.9851C41.5305 42.4448 42.1408 41.5625 42.4255 40.3384C42.7027 39.1014 42.4861 37.8675 41.7755 36.6367C41.0575 35.3931 40.0909 34.5923 38.8755 34.2341C37.673 33.8685 36.5782 33.9707 35.591 34.5407C34.6167 35.1032 33.9862 35.9801 33.6995 37.1712C33.4257 38.3549 33.6663 39.6006 34.4212 40.9083Z",
    fill: "#4F75F4"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 80,
    r: 7,
    fill: "#2AD2F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 77.5,
    r: 4.5,
    fill: "white",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 82.5,
    r: 5.5,
    fill: "#78D081"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 80.5,
    r: 3.5,
    fill: "white",
    fillOpacity: 0.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_16326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.28 44.1373L71.8406 57.672L80.0917 69.9176L80.28 44.1373Z",
    fill: "#CBBAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2798 44.137L57.2065 55.6476L71.8404 57.6717L80.2798 44.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1461 71.2313L57.4109 80.4291L78.7351 71.7236L63.1461 71.2313Z",
    fill: "#CBBAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4473 80.7554L63.1825 71.5576L55.8799 57.7761L57.4473 80.7554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5091 69.4292L80.0914 69.9173L71.8362 57.6783L64.5091 69.4292Z",
    fill: "#9A77E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2062 55.6473L64.5088 69.4289L71.8359 57.6781L57.2062 55.6473Z",
    fill: "#CBBAF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_55_16326",
    x: 5,
    y: 3,
    width: 62,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226188 0 0 0 0 0.394812 0 0 0 0 0.948861 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_55_16326"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_55_16326",
    x: 19.1814,
    y: 16.1588,
    width: 35.9639,
    height: 38.5085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.453987 0 0 0 0 0.992157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_16326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_16326",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_55_16326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_16326",
    x1: 88,
    y1: 0.0000104904,
    x2: 0.0000104904,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_16326",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F9CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A89E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_16326",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F9CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A89E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_16326",
    x1: 8,
    y1: 7,
    x2: 67,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_16326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9772,
    height: 43.1541,
    fill: "white",
    transform: "translate(68.8333 37) rotate(31.9452)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrxwingoRound5M);
export default __webpack_public_path__ + "static/media/trxwingo_round_5m.9df9afec1cbb7c4a6a1a47853fd3c7a9.svg";
export { ForwardRef as ReactComponent };